import { COLORS } from '../../constants/colors';

export default {
  icon: {
    fill: COLORS.text,
  },
};
